const defaultshowkeywords = true;
const defaultfilteryear = true;
const defaultfiltergroupids = "";
const defaultparentid = -1;
const defaultpagesize = 20;
const defaultresultType = "Result";
const defaultpersonalisationgroupids = "";
const defaultlocale = "en";

const indexElement = document.getElementById("sm-resource-index");

const showkeywords =
  indexElement?.getAttribute("data-showkeywords") == null
    ? defaultshowkeywords
    : indexElement.getAttribute("data-showkeywords")?.toLowerCase() === "true";
const filteryear =
  indexElement?.getAttribute("data-filteryear") == null
    ? defaultfilteryear
    : indexElement.getAttribute("data-filteryear")?.toLowerCase() === "true";
const filtergroupids =
  indexElement?.getAttribute("data-filtergroupids") ?? defaultfiltergroupids;

const resulttype =
  indexElement?.getAttribute("data-resulttype") ?? defaultresultType;

let parentid = defaultparentid;
const castparentid = Number(indexElement?.getAttribute("data-parentid"));
if (!isNaN(castparentid) && castparentid !== 0) parentid = castparentid;

let pagesize = defaultpagesize;
const castpagesize = Number(indexElement?.getAttribute("data-pagesize"));
if (!isNaN(castpagesize) && castpagesize !== 0) pagesize = castpagesize;

const title = indexElement?.getAttribute("data-title");
const description = indexElement?.getAttribute("data-description");

const url = indexElement?.getAttribute("data-baseuri");
const language = indexElement?.getAttribute("data-language");
const locale =
  indexElement?.getAttribute("data-locale") == null ? defaultlocale : indexElement.getAttribute("data-locale");


const personalisationgroupids =
  indexElement?.getAttribute("data-personalisationgroupids") ??
  defaultpersonalisationgroupids;

const config = {
  showkeywords: showkeywords,
  filtergroupids: filtergroupids,
  filteryear: filteryear,
  parentid: parentid,
  pagesize: pagesize,
  title: title,
  description: description,
  resultType: resulttype,
  baseUri: url,
  locale: locale,
  language: language,
  personalisationGroupIds: personalisationgroupids
};

export default config;
